import gql from 'graphql-tag';

export const SetRelationMutation = gql`
	mutation SetRelationMutation($input: UpdateRelationInput!) {
		updateRelation(input: $input) {
			targetKey
			sourceKey
			relationName
			url
		}
	}
`;
